import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ViewManagerService } from '../../../../core/services/view-manager-service';
import { ScadenzarioAutoAddFormComponent } from '../../../form/scadenzario/scadenzario-auto-add-form.component';
import { ScadenzarioRequest } from '../../../models/scadenzario-request';
import { ApplicaScadenzeRequest } from '../../../models/scadenzario/applica-scadenze-request';
import { InserisciScadenze } from '../../../models/scadenzario/inserisci-scadenze';
import { CalcoloScadenze } from '../../../models/scadenzario/request-calcolo-scadenze';
import { ScadenzaAuto } from '../../../models/scadenzario/scadenza-auto';
import { ScadenzeTrovate } from '../../../models/scadenzario/scadenze-trovati';
import { Natura } from '../../../models/tipologiche/natura';
import { ConfigurazioneScadenzarioSearch } from 'src/app/amministrazione/models/configurazione-scadenzario-search';

@Component({
    moduleId: module.id.replace('/dist/', '/'),
    selector: 'div [scadenzario-form-auto-add]',
    templateUrl: '../../../form/scadenzario/scadenzario-auto-add-form.component.html',
    host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ScadenzaAutoAddFormComponent extends ScadenzarioAutoAddFormComponent implements OnInit {
    @Input() isAtto: boolean;
    @Input() isEsito: boolean;

    @Output() onReturn: EventEmitter<any> = new EventEmitter<any>();
    scadenzaIns: any;

    request: CalcoloScadenze;
    entita: any;
    patrono: boolean = false;
    sospensioniForm: FormGroup;
    scadenzeTrovate: ScadenzeTrovate[] = [];
    scadenzeSelezionate: any[] = [];
    requestApplicaScadenze: ApplicaScadenzeRequest;


    numPag: number = 0;
    isDataInsAgosto: boolean = false;
    abbreviazTermini: boolean = false;
    sospFeriale: boolean = false;

    sospensionePersonalizzata: boolean = false;

    isLoadingPag2: boolean = false;
    listaScadenzeAuto: ScadenzaAuto[] = [];
    isLoadingInsScad: boolean = false;
    termineLibero: boolean = false;

    tipoPratica: string;
    tipoFascicolo: string;
    idGrado: string;

    constructor(
        @Inject(OperationsService) operationService: OperationsService,
        @Inject(FormBuilder) campiForm: FormBuilder,
        @Inject(HelpersService) helpers: HelpersService,
        private viewManager: ViewManagerService
    ) {
        super(operationService, campiForm, helpers);
    }

    ngOnInit() {
        this.setTitle('Calcolo automatico scadenze');
        this.isInserimento(true);
    }

    initForm() {
        this.patrono = false;
        this.abbreviazTermini = false;
        this.sospFeriale = false;
        this.sospensionePersonalizzata = false;
        this.termineLibero = false;
        this.request = new CalcoloScadenze();
        this.requestApplicaScadenze = new ApplicaScadenzeRequest();
        this.populateForm();
    }

    inizializzaComponent(entita: any, ricercaEffettuata: ScadenzarioRequest, naturaFasciolo: Natura, idEntita, idFascicolo: string) {
        this.initForm();
        if (naturaFasciolo.label == 'ATTIVO') {
            this.request.attore = true;
        } else {
            this.request.attore = false;
        }
        this.request.idData = entita.id ? entita.id : idEntita;
        this.request.tipoFascicolo = ricercaEffettuata.tipoFascicolo;
        this.request.tipoPratica = ricercaEffettuata.tipoPratica;
        this.request.tipoScadenza = ricercaEffettuata.tipoScadenza;
        this.request.motivoScadenza = ricercaEffettuata.motivoScadenza;
        this.request.tipoAtto = ricercaEffettuata.tipoAtto;
        this.request.tipoEsito = ricercaEffettuata.tipoEsito;
        this.request.grado = ricercaEffettuata.grado;
        this.request.sospensioneFeriale = false;
        this.request.tipoRicorso = ricercaEffettuata.tipoRicorso;

        this.requestApplicaScadenze.idFascicolo = idFascicolo;

        this.numPag = 1;
        this.entita = entita;
        this.searchTermini();
    }

    changeRadioButton(tipo: string) {
        switch (tipo) {
            case 'sospensioneFeriale': {

                if (this.sospFeriale) {
                    this.request.sospensioneFeriale = true;
                } else {
                    this.request.sospensioneFeriale = false;
                }
                break;
            }
            case 'abbreviazioneTermini': {

                if (this.abbreviazTermini) {
                    this.sospensioniForm.controls['giorniAbbreviazione'].setValidators([Validators.required]);
                    this.sospensioniForm.controls['giorniAbbreviazione'].updateValueAndValidity();
                } else {
                    this.sospensioniForm.controls['giorniAbbreviazione'].setValidators([]);
                    this.sospensioniForm.controls['giorniAbbreviazione'].updateValueAndValidity();
                    this.request.giorniAbbreviazione = null;
                }
                break;
            }
            case 'personalizzata': {

                if (this.sospensionePersonalizzata) {
                    this.sospensioniForm.controls['dataSospensioneDa'].setValidators([Validators.required]);
                    this.sospensioniForm.controls['dataSospensioneDa'].updateValueAndValidity();
                    this.sospensioniForm.controls['dataSospensioneA'].setValidators([Validators.required]);
                    this.sospensioniForm.controls['dataSospensioneA'].updateValueAndValidity();
                } else {
                    this.sospensioniForm.controls['dataSospensioneDa'].setValidators([]);
                    this.sospensioniForm.controls['dataSospensioneDa'].updateValueAndValidity();
                    this.sospensioniForm.controls['dataSospensioneA'].setValidators([]);
                    this.sospensioniForm.controls['dataSospensioneA'].updateValueAndValidity();
                    this.request.dataSospensioneA = null;
                    this.request.dataSospensioneDa = null;
                }
                break;
            }
            case 'patrono': {
                if (this.patrono) {
                    this.request.giornoPatrono = true;
                } else {
                    this.request.giornoPatrono = false;
                }
                break;
            }
            case 'termineLibero': {

                if (this.termineLibero) {
                    this.request.termineLibero = true;
                } else {
                    this.request.termineLibero = false;
                }
                break;
            }
        }
    }

    populateForm() {
      this.sospensioniForm = this.campiForm.group({
        dataSospensioneDa: [this.request.dataSospensioneDa],
        dataSospensioneA: [this.request.dataSospensioneA],
        giornoPatrono: [this.request.giornoPatrono],
        giorniAbbreviazione: [this.request.giorniAbbreviazione],
        sospensioneFeriale: [this.sospFeriale],
        termineLibero: [this.termineLibero]
      });
      if (this.sospFeriale) this.changeRadioButton('sospensioneFeriale');
      if (this.termineLibero) this.changeRadioButton('termineLibero');
      if (this.abbreviazTermini) this.changeRadioButton('abbreviazioneTermini');
    }

    /* let dataCheck = new Date(scadenzaIns.dataScadenza);
        if(dataCheck.getMonth() == 7){
            this.isDataInsAgosto = true;
        }
        else{
            this.isDataInsAgosto = false;
        }
        */
    calcolaTermini() {
        this.scadenzeTrovate = [];
        this.operationService.getScadenzeCalcolate('calcolo', this.request).subscribe(res => {
            if (res) {
                res.forEach(element => {
                    this.scadenzeTrovate.push(new ScadenzeTrovate(element))
                });
                this.numPag = 2
                console.log(this.scadenzeTrovate)
            }
        })
    }

    addScadenza(scadenza) {
        this.scadenzeSelezionate = [];
        if (scadenza.selezionato) {
            this.scadenzeSelezionate.push(scadenza)
        } else {
            this.scadenzeSelezionate.splice(this.scadenzeSelezionate.findIndex(el => el.id === scadenza.id), 1)
        }
        console.log(this.scadenzeSelezionate)
    }


    indietro(): void {
        this.numPag = 1;
        this.isLoadingPag2 = false;
        this.isLoadingInsScad = false;
    }

    gestisciSelezionaTutti(event: boolean) {
        if (event) {
            this.scadenzeTrovate.forEach(termine => {
                termine.selezionato = true;
                if (this.scadenzeSelezionate.length > 0) {
                    if (this.scadenzeSelezionate.findIndex(s => s.id === termine.id) === -1) {
                        this.scadenzeSelezionate.push(termine)
                    }
                } else {
                    this.scadenzeSelezionate.push(termine)
                }
            })
        } else {
            this.scadenzeTrovate.forEach(termine => {
                termine.selezionato = false;
                this.scadenzeSelezionate = [];
            })
        }
    }

    checkSelezionati(): boolean{
       if(this.scadenzeTrovate.findIndex(el => el.selezionato === false) != -1){
           return false;
       }else{
           return true;
       }
    }

    inserisciTermini(): void {

        //Disabilita i tasti
        this.isLoadingInsScad = true;
        this.requestApplicaScadenze.scadenze = [];
        this.scadenzeSelezionate.forEach(scadenza => {
            this.requestApplicaScadenze.scadenze.push(new InserisciScadenze(scadenza))
        });
        this.operationService.inserisciScadenze('scadenze', this.requestApplicaScadenze).subscribe(res => {
            if (res) {
                this.onReturn.emit(res);
            }
        })
    }

    searchTermini(): void {
      let req: ConfigurazioneScadenzarioSearch = new ConfigurazioneScadenzarioSearch();
      req.tipoFascicolo = this.request.tipoFascicolo;
      req.tipoPratica = this.request.tipoPratica;
      req.tipoScadenza = this.request.tipoScadenza;
      req.motivoScadenza = this.request.motivoScadenza;
      req.tipoAtto = this.request.tipoAtto;
      req.tipoEsito = this.request.tipoEsito;
      this.operationService.getTerminiScadenzario(req).subscribe((res) => {
        if(!!res && !!res.items && res.items.length > 0){
          let termini: any[] = res.items;
          this.termineLibero = termini.some((t) => t.termineLibero);
          this.sospFeriale = termini.some((t) => t.sospensioneFeriale);
          this.abbreviazTermini = termini.some((t) => t.abbreviazioneTermini);
          this.populateForm();
        }
      });
    }
}
